<div
  class="circle {{ circleClass }}"
  *ngFor="let circleClass of circleColorClasses"
></div>
